import React from "react";
import GenericPullAndPushToolView from '../GenericPullAndPushToolView';
import CheckmarxOneCredentialForm from "./CheckmarxOneCredentialForm";
import CheckmarxOneConfigListing from "./CheckmarxOneConfigListing";

export default function CheckmarxOnePullAndPushView(props){
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={CheckmarxOneCredentialForm}
            PullConfigListingView={CheckmarxOneConfigListing}
        />
    )
}